/*
 * @Description:
 * @Autor: lichao
 * @Date: 2022-01-05 09:54:38
 * @LastEditors: lichao
 * @LastEditTime: 2022-01-05 14:17:52
 */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "lib-flexible";
import "zarm/dist/zarm.css";
import "./index.less";
import App from "./App";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
